<script>
    import { onMount } from "svelte";
    import Cinema from "../components/Cinema.svelte";
    import ajaxFetch from "../services/ajaxFetch";

    let { errorCallback, variationId, featureIndex, performance, eventMergeId, cinemaInjectionContainerWidth } =
        $props();

    let cinemaHasLoaded = $state(false);
    let recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state(),
        hasPersonalisedRecommendations = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const res = await ajaxFetch(`/reco-core/recommendations/bouncelayer/variations/${variationId}`);
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            featuresState,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <Cinema
        {recommendations}
        {tracking}
        {featureIndex}
        {additionalClickTracking}
        {featuresState}
        {cinemaInjectionContainerWidth}
        cinemaMeta={metaData}
        {performance}
        site="RecoDetailViewAlternativeBounceLayer"
        trackingEventMergeId={eventMergeId}
        loadedTrackingActionName="automatic"
        personalisedUser={hasPersonalisedRecommendations}
    />
{/if}
